
/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$('document').ready(function() {
    AOS.init();

    initHeaderBar();

    initSliderMargin()
    //initSlider();
    initFindTheKitSwiper();
    //initBrandSwiper();
    initCustomerReviewsSwiper();
    //initProductsSwiper();
    //initInfluencerSwiper();
    initInstallSwiper();
    initProductReviews();
  
    //initProductDropdownMenu();
    //initMainStory();
    //initProductSpecificationDropdown();
    
    function initSliderMargin(){
      if (typeof jQuery == undefined) {
        $(".page-type-index [id^='shopify-section-template--']:eq(0), .page-type-collection [id^='shopify-section-template--']:eq(0)").css({
          marginTop: `calc(-1 * var(--header-height))`
        });
      } else {
        if ($("#mobile-facet-toolbar").length == 1) {
          $("#mobile-facet-toolbar").next(".shopify-section").css({
            marginTop: `calc(-1 * var(--header-height))`
          });
        } else if ($(".shopify-section.shopify-section--mini-cart").length == 1) {
          $(".shopify-section.shopify-section--mini-cart").next(".shopify-section").not('.shopify-section--main-product').css({
            marginTop: `calc(-1 * var(--header-height))`
          }); 
        } else if ($(".shopify-section.shopify-section--header").length == 1) {
          $(".shopify-section.shopify-section--header").next(".shopify-section").css({
            marginTop: `calc(-1 * var(--header-height))`
          });
        }
      }

    }

    function initProductSpecificationDropdown () {
        if (isMobile) {
            return;
        }
        $('.shopify-section--product-specification .dropdown-item').each(function (index, item) {
            $(this).css({
                maxHeight: $(this).find('.circle').height()
            })
        })
        $('.shopify-section--product-specification .dropdown-item').click(function () {
            if ($(this).hasClass('open')) {
                $(this).removeClass('open');
                $(this).css({
                    maxHeight: $(this).find('.circle').height()
                })
            } else {
                $(this).addClass('open');
                console.log($(this).attr('data-height'))
                $(this).css({
                    maxHeight: 500
                })
            }
        })
        $('.shopify-section--product-specification .dropdown-item:eq(0)').click();
    }

    function initMainStory () {
        if (isMobile) {
          /*$('.story-item').click(function() {
              $(this).parent().find('.story-item').removeClass('is-grow');
              $(this).addClass('is-grow');
          });*/
        } else {
          $('.story-item').hover(function() {
              $(this).parent().find('.story-item').removeClass('is-grow');
              $(this).addClass('is-grow');
          });
        }
    }

    function initProductDropdownMenu () {
        $('body').on('click', 'span.up', function () {
            $(this).removeClass('up').addClass('down');
            $('.dropdown-wrapper').removeClass('close');
        })
        $('body').on('click', 'span.down', function () {
            $(this).removeClass('down').addClass('up');
            $('.dropdown-wrapper').addClass('close');
        })
    }

    function initProductReviews () {
        let swiper = new Swiper(".swiper-product-reviews", {
            pagination: {
              el: ".swiper-pagination",
              clickable: true
            },
        });
    }

    function initInstallSwiper () {
        let installSwiper = new Swiper('.swiper-install', {
            slidesPerView: 1
        });
        /*let installSwiperThumb = new Swiper('.swiper-install-thumb', {
            slidesPerView: 3,
            spaceBetween: 1,
            grid: {
                rows: 2,
            },
            breakpoints: {
                740: {
                    slidesPerView: 6,
                    spaceBetween: 2,
                    grid: {
                        rows: 1,
                    }
                }
            },
            thumbs: {
                swiper: installSwiper,
            },
            navigation: {
                nextEl: ".swiper-button-next.custom",
                prevEl: ".swiper-button-prev.custom",
            }
        });*/
        $('.shopify-section--product-install-new .tab-swiper--pin .swiper-slide').click(function () {
            $(this).parent().find('.swiper-slide').removeClass('swiper-slide-active');
            $(this).addClass('swiper-slide-active');
            let _index = parseInt($(this).attr('index')) - 1;
            installSwiper.slideTo(_index);
        })
        $('.shopify-section--product-install-new .tab-swiper--pin .swiper-slide-active').click();
    }

    function initInfluencerSwiper () {
        if (isMobile) {
            let influencerSwiper = new Swiper(".swiper-influencer", {
                slidesPerView: 'auto',
                centeredSlides: true,
                slideClass: 'video-item',
                navigation: {
                    nextEl: ".swiper-button-next-custom",
                    prevEl: ".swiper-button-prev-custom",
                },
                on: {
                    init: function (sw) {
                        sw.slideTo(Math.ceil(sw.slides.length / 2) - 1);
                    }
                }
            });
        }
    }

    function initProductsSwiper () {
        let productsSwiper = new Swiper(".featured-collections-pro .swiper", {
            slidesPerView: 1,
            spaceBetween: 0,
            freeMode: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                740: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                }
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
                draggable: true,
            },
            slideClass: 'product-item',
        });
    }

    function initCustomerReviewsSwiper () {
        if (isMobile) {
          let customerReviewsSwiper = new Swiper(".customer-reviews-swiper", {
              slidesPerView: '1.4',
              spaceBetween: 8,
              navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
              }
          });
        } else if (window.screen.width <= 1024){
          let customerReviewsSwiper = new Swiper(".customer-reviews-swiper", {
              slidesPerView: '1.6',
              spaceBetween: 16,
              navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
              }
          });
        }        
        else {
          let customerReviewsSwiper = new Swiper(".customer-reviews-swiper", {
              slidesPerView: 'auto'
          });
        }
    }

    function initBrandSwiper () {
        new Swiper(".swiper-brand", {
            slidesPerView: 'auto',
            spaceBetween: 13,
            grid: {
                rows: 3,
            },
            breakpoints: {
                740: {
                    grid: {
                        rows: 2,
                    },
                }
            }
        });
    }
    
    function initFindTheKitSwiper () {
        new Swiper('.shopify-section--find-right-kit-pc .tab-swiper', {
            slidesPerView: 'auto',
            loop: true,
            slidesPerView: 2.7,
            spaceBetween: 10,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
                1024: {
                    slidesPerView: 3,
                    loop: false,
                    spaceBetween: 16,
                },
                1200: {
                    slidesPerView: 5,
                    spaceBetween: 40,
                    
                },
                1400: {
                    slidesPerView: 5,
                    spaceBetween: 40,
                },
                1920: {
                    slidesPerView: 5,
                    spaceBetween: 40,
                }
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
        });
        let tabBodySwiper = new Swiper('.shopify-section--find-right-kit-pc .tab-body-swiper', {
            slidesPerView: 1,
        });
        $('.tab-swiper .swiper-slide').click(function () {
            $(this).parent().find('.swiper-slide').removeClass('active');
            $(this).addClass('active');
            let _index = parseInt($(this).attr('index')) - 1;
            tabBodySwiper.slideTo(_index);
        })
        $('.tab-swiper .swiper-slide-active').click();
    }

    function initSlider () {
      if (typeof jQuery == undefined) {
        $(".page-type-index [id^='shopify-section-template--']:eq(0), .page-type-collection [id^='shopify-section-template--']:eq(0)").css({
          marginTop: (0 - $('store-header').height()) + 'px'
        });
      } else {
        if ($("#mobile-facet-toolbar").length == 1) {
          $("#mobile-facet-toolbar").next(".shopify-section").css({
            marginTop: (0 - $('store-header').height()) + 'px'
          });
        } else if ($(".shopify-section.shopify-section--mini-cart").length == 1) {
          $(".shopify-section.shopify-section--mini-cart").next(".shopify-section").not('.shopify-section--main-product').css({
            marginTop: (0 - $('store-header').height()) + 'px'
          }); 
        } else if ($(".shopify-section.shopify-section--header").length == 1) {
          $(".shopify-section.shopify-section--header").next(".shopify-section").css({
            marginTop: (0 - $('store-header').height()) + 'px'
          });
        }
      }
    }
  function diyebckitRiderStories() {
    if(window.innerWidth < 1025 ){
        $(".template-page-diyebckit-rider .shopify-section--mini-cart").next(".shopify-section").css({
        marginTop:'0px'
        });
      } else {
        $(".template-page-diyebckit-rider .shopify-section--mini-cart").next(".shopify-section").css({
          marginTop: (0 - $('store-header').height()) + 'px'
        }); 
      }
  }
  function becomeOurDealer() {
    if(window.innerWidth < 1025 ){
        $(".template-page-become-our-dealer .shopify-section--mini-cart").next(".shopify-section").css({
        marginTop:'0px'
        });
      } else {
        $(".template-page-become-our-dealer .shopify-section--mini-cart").next(".shopify-section").css({
          marginTop: (0 - $('store-header').height()) + 'px'
        }); 
      }
  }
  function faqs() {
    if(window.innerWidth < 1025 ){
        $(".template-page-faq .shopify-section--mini-cart").next(".shopify-section").css({
        marginTop:'0px'
        });
      } else {
        $(".template-page-faq .shopify-section--mini-cart").next(".shopify-section").css({
          marginTop: (0 - $('store-header').height()) + 'px'
        }); 
      }
  }
  function ReturnExchangePolicy() {
    if(window.innerWidth < 1025 ){
        $(".template-page-return-and-exchange-policy .shopify-section--mini-cart").next(".shopify-section").css({
        marginTop:'0px'
        });
      } else {
        $(".template-page-return-and-exchange-policy .shopify-section--mini-cart").next(".shopify-section").css({
          marginTop: (0 - $('store-header').height()) + 'px'
        }); 
      }
  }
  function contactUs() {
    if(window.innerWidth < 1025 ){
        $(".template-page-contact .shopify-section--mini-cart").next(".shopify-section").css({
        marginTop:'0px'
        });
      } else {
        $(".template-page-contact .shopify-section--mini-cart").next(".shopify-section").css({
          marginTop: (0 - $('store-header').height()) + 'px'
        }); 
      }
  }
  function sizeGuide() {
    if(window.innerWidth < 1025 ){
        $(".template-page-size .shopify-section--mini-cart").next(".shopify-section").css({
        marginTop:'0px'
        });
      } else {
        $(".template-page-size .shopify-section--mini-cart").next(".shopify-section").css({
          marginTop: (0 - $('store-header').height()) + 'px'
        }); 
      }
  }
  function support() {
    if(window.innerWidth < 1199 ){
        $(".template-page-support .shopify-section--mini-cart").next(".shopify-section").css({
        marginTop:'0px'
        });
      } else {
        $(".template-page-support .shopify-section--mini-cart").next(".shopify-section").css({
          marginTop: (0 - $('store-header').height()) + 'px'
        }); 
      }
  }
  function aboutUs() {
    if(window.innerWidth < 1025 ){
        $(".template-page-about .shopify-section--mini-cart").next(".shopify-section").css({
        marginTop:'0px'
        });
      } else {
        $(".template-page-about .shopify-section--mini-cart").next(".shopify-section").css({
          marginTop: (0 - $('store-header').height()) + 'px'
        }); 
      }
  }

  function ourMission() {
    if(window.innerWidth < 1025 ){
        $(".template-page-our-mission .shopify-section--mini-cart").next(".shopify-section").css({
        marginTop:'0px'
        });
      } else {
        $(".template-page-our-mission .shopify-section--mini-cart").next(".shopify-section").css({
          marginTop: (0 - $('store-header').height()) + 'px'
        }); 
      }
  }
  
  
  diyebckitRiderStories();
  becomeOurDealer();
  faqs();
  ReturnExchangePolicy();
  contactUs();
  sizeGuide();
  support();
  aboutUs();
  ourMission();
  
  $(window).resize(function(){
    diyebckitRiderStories();
    becomeOurDealer();
    faqs();
    ReturnExchangePolicy();
    contactUs();
    sizeGuide();
    support();
    aboutUs();
    ourMission();
  })

    function initHeaderBar () {
        $(window).scroll((function () {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > 100) {
                $('store-header').addClass('scrolled');
            } else {
                $('store-header').removeClass('scrolled');
            }
        }))
    }
})


$( document ).ready(function() {

    $(document).on('mouseover', '.swiper-influencer .video-item', function(){
        $('.swiper-influencer .video-item').removeClass('video-active').removeClass('next-video').removeClass('prev-video')
        $(this).addClass('video-active').next().addClass('next-video').prev().addClass('prev-video')
    })
  
    $('.shopify-section--influencer-reviews-pc').find('.video-item.index-3').addClass('video-active');
    $('.swiper-influencer').find('.video-item.video-active').prev().addClass('prev-video');
    $('.swiper-influencer').find('.video-item.video-active').next().addClass('next-video');
  
      $( '.shopify-section--influencer-reviews-pc .swiper-button-next-custom' ).click(function() {
        var active_video = $(this).closest('.swiper-influencer').find('.video-item.video-active');
        if (active_video.next().length > 0) {
          active_video.removeClass('video-active');
          active_video.next().addClass('video-active');
          active_video.next().removeClass('next-video');
          active_video.next().next().addClass('next-video');
          active_video.prev().removeClass('prev-video');
          active_video.addClass('prev-video');
        }
      });
    
      $( '.shopify-section--influencer-reviews-pc .swiper-button-prev-custom' ).click(function() {
        var active_video = $(this).closest('.swiper-influencer').find('.video-item.video-active');
        if (active_video.prev().length > 0) {
          active_video.removeClass('video-active');
          active_video.prev().addClass('video-active');
          active_video.next().next().removeClass('next-video');
          active_video.addClass('next-video');
          active_video.prev().removeClass('prev-video');
          active_video.prev().prev().addClass('prev-video');
        }
      });


      
  
   // footer accordion
      if (window.screen.width <= 1024) {
        function footerMenu() {
          $('.footer__inner-wrapper-right .footer__item-title').click(function(e) {
              e.preventDefault();
              var $this = $(this);
              if (!$this.hasClass("accordion-active")) {
                  $(".footer__inner-wrapper-right .footer__item-content").slideUp(600);
                  $(".footer__inner-wrapper-right .footer__item-title").removeClass("accordion-active");
                  // $('.accordion__arrow').removeClass('accordion__rotate');
              }
              $this.toggleClass("accordion-active");
              $this.next().slideToggle();
              // $('.accordion__arrow',this).toggleClass('accordion__rotate');
          });
        }
        footerMenu();
        // $(window).resize(function(){
        //   footerMenu();
        // });
      }

  // product faq
  $(".collapsible-togglee").click(function() {
    if ($('.collapsiblee').is(':visible')) {
      $(".collapsiblee").slideUp(400);
      $(".collapsiblee .plusminus").text('+');
    }
    if ($(this).next(".collapsiblee").is(':visible')) {
      $(this).next(".collapsiblee").slideUp(400);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".collapsiblee").slideDown(400);
      $(this).children(".plusminus").text('-');
    }
  });

  document.querySelectorAll('.swiperPro').forEach(function(root){
    var pc    = parseFloat(root.dataset.pcRow)    || 3; 
    var ipad  = parseFloat(root.dataset.ipadRow)  || 2; 
    var mobile = parseFloat(root.dataset.mobileRow)|| 1; 
    var gridRows = parseFloat(root.dataset.gridRows)|| 1; 
    var prevEl = root.parentElement.querySelector('.swiper-button-prev');
    var nextEl = root.parentElement.querySelector('.swiper-button-next');
    var gapMobile = 10, gapIpad = 20, gapPc = 30;

    new Swiper(root, {
      slidesPerView: pc,
      grid: { rows: gridRows, fill: 'row' },
      spaceBetween: gapPc,
      navigation: { 
        nextEl: nextEl,
        prevEl: prevEl,
       },

      breakpoints: {
        0: {              
          slidesPerView: mobile,
          spaceBetween: gapMobile
        },
        768: {
          slidesPerView: ipad,
          spaceBetween: gapIpad
        },
        1280: {
          slidesPerView: pc,
          spaceBetween: gapPc
        }
      }
    });
  });

  //  var swiper = new Swiper(".swiperPro", {
  //       slidesPerView: 3,
  //       spaceBetween: 20,
  //        navigation: {
  //         nextEl: ".swiper-button-next",
  //         prevEl: ".swiper-button-prev",
  //       },
  //    breakpoints: { 
  //     320: {  
  //       slidesPerView: 1,
  //       spaceBetween: 10
  //     },
  //     768: {   
  //       slidesPerView: 3,
  //       spaceBetween: 20
  //     },
  //     1280: {  
  //       slidesPerView: 3,
  //       spaceBetween: 30
  //     }
  //   }
  // });
});
$('.ttt_bbfb49a1-be58-472c-bbc2-cdb9dd165548').hide();
$('.ttt_Universal').click(function(){
  $('.ttt_7ff5a7e1-2623-4f79-a8b1-4a43db4afae6').show();
  $('.ttt_bbfb49a1-be58-472c-bbc2-cdb9dd165548').hide();
})
$('.ttt_Brompton').click(function(){
  $('.ttt_7ff5a7e1-2623-4f79-a8b1-4a43db4afae6').hide();
  $('.ttt_bbfb49a1-be58-472c-bbc2-cdb9dd165548').show();
})
